import React, { Fragment, useMemo } from "react";
import { Grid } from "@mui/material";
import {
  propsBarPressCard,
  propsCo2Card,
  propsLuxCard,
  propsPCountCard,
  propsPM10Card,
  propsPM2_5Card,
  propsRainCard,
  propsRainPeakCard,
  propsTempertureCard,
  propsUmidityCard,
  propsWindCard,
  propsWindDirCard,
} from "constants/metrics";
import MetricCard from "./metrics/MetricCard.component";
import { useTranslation } from "react-i18next";
import { WIND_DIRECTION_DICT } from "constants/wind";

const DataCurrentColorCard = ({ dataCurrent, onClickCard = () => { }, isHome }) => {
  const { t } = useTranslation()
  const cardsValues = useMemo(() =>
  ({
    air_temp: {
      label: t('temperature'),
      props: propsTempertureCard,
    },
    air_hum: {
      label: t('humidity'),
      props: propsUmidityCard,
    },
    CO2: {
      label: "CO2",
      props: propsCo2Card,
    },
    lux: {
      label: t('illuminance'),
      props: propsLuxCard,
    },

    rain_intensity: {
      label: t('Rainfall intensity'),
      props: propsRainCard,
    },
    rain_intensity_peak: {
      label: t('precipitation-peak'),
      props: propsRainPeakCard,
    },
    wind_speed: {
      label: t('wind-speed'),
      props: propsWindCard,
    },
    wind_dir_idx: {
      label: t('wind-direction'),
      props: propsWindDirCard,
    },
    pm10: {
      label: "PM 10",
      props: propsPM10Card,
    },
    pm2_5: {
      label: "PM 2.5",
      props: propsPM2_5Card,
    },
    bar_press: {
      label: t('atmospheric-pressure'),
      props: propsBarPressCard,
    },
    pcount: {
      label: t('people-counter'),
      props: propsPCountCard,
    }
  })
    , [t])

  return (
    <Grid container spacing={2}>
      {dataCurrent &&
        Object.keys(cardsValues).map((key) => (
          <Fragment key={key}>
            {(
              <Grid item xs={12} sm={6} md={isHome ? 6 : 4} lg={isHome ? 4 : 3}>
                <MetricCard
                  isTrend={true}
                  label={cardsValues[key]?.label}
                  {...cardsValues[key]?.props}
                  symbol={dataCurrent[key]?.data !== null ?
                    t(cardsValues[key]?.props?.symbol)
                    : ''
                  }
                  data={
                    key === "wind_dir_idx"
                      ? ((dataCurrent["wind_dir_idx"]?.data === null ||
                        dataCurrent["wind_speed"]?.data === null ||
                        dataCurrent["wind_speed"]?.data === 0)
                        ? { data: null }
                        : {
                          data: t(WIND_DIRECTION_DICT[dataCurrent[key]?.data]),
                          trend: dataCurrent[key]?.trend,
                        })
                      : dataCurrent[key]
                  }
                  onClickCard={() => onClickCard(key)}
                />
              </Grid>
            )}
          </Fragment>
        ))}
    </Grid>
  );
};

export default DataCurrentColorCard;


